/** @jsxImportSource @emotion/react */
'use memo'

import css from '@emotion/css/macro'
import SectionHeader from 'src/components/ts-components/SectionHeader'
import { REGISTRATION_SECTION_HEADERS } from '../constants/registrationSectionHeaders'
import { balanceLabel, balanceText } from '../utils/balanceI18n'
import type { RegistrationSubTab } from '../utils/registrationSubTabs'

interface RegistrationSectionHeaderProps {
  subTab: RegistrationSubTab
}

/** The active Registration tab section's title row + subtitle, if it has one. */
const RegistrationSectionHeader = ({
  subTab,
}: RegistrationSectionHeaderProps) => {
  const config = REGISTRATION_SECTION_HEADERS[subTab]
  if (!config) {
    return null
  }

  return (
    <div css={wrapStyle}>
      <SectionHeader
        title={balanceLabel(config.titleKey)}
        subtitle={balanceText(config.subtitleKey)}
        helpUrl={config.helpUrl}
        helpLabel={balanceLabel(config.helpLabelKey)}
        isBeta={config.isBeta}
      />
    </div>
  )
}

export default RegistrationSectionHeader

// Section separation below the scope row.
const wrapStyle = css`
  margin-top: 24px;
`
